import { styled } from 'goober';
import { forwardRef } from 'react';

export const LabelsWrapper = styled('div')<{ $marginTop?: boolean }>(({ $marginTop = false }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    marginTop: $marginTop ? '4px' : '0',
    overflow: 'hidden',
    borderRadius: '6px',
    alignItems: 'center',
}));

export const StyledLabel = styled('div')<{ $color?: string; $removable?: boolean; $pointer?: boolean }>(
    ({ theme, $color, $removable = false, $pointer }) => ({
        cursor: $pointer && !$removable ? 'pointer' : 'default',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '24px',
        padding: `3px ${$removable ? '0' : '8px'} 4px 8px`,
        borderRadius: '6px',
        border: '1px solid',
        color: $color ? $color : theme.colors.neutral.w100,
        borderColor: $color ? $color : theme.colors.neutral.w100,
        userSelect: 'none',
        whiteSpace: 'nowrap',
        backgroundColor: 'white',
    })
);

export const AddLabelBtnWrap = styled(
    'div',
    forwardRef
)(() => ({
    paddingLeft: '4px',
    position: 'sticky',
    right: 0,
    backgroundColor: 'inherited',
}));

export const AddLabelButton = styled(
    'div',
    forwardRef
)(({ theme }) => ({
    height: '24px',
    borderRadius: '6px',
    border: '1px solid',
    color: theme.colors.neutral.w700,
    borderColor: theme.colors.neutral.w100,
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: 'white',
}));

export const LabelsRow = styled('div')<{ $crop?: boolean }>(({ $crop = false }) => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: $crop ? 'nowrap' : 'wrap',
    height: $crop ? '25px' : '40px',
    width: '100%',
    gap: '4px',
    overflowX: $crop ? 'clip' : 'auto',
    alignItems: 'center',
}));

export const AddLabelContainer = styled('div')(() => ({
    height: '206px',
    width: '200px',
    overflow: 'hidden',
}));

export const LabelsCol = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '4px',
    overflow: 'scroll',
}));

export const CreateLabel = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    marginTop: '10px',
    padding: '4px 8px',
    gap: '10px',
    justifyContent: 'start',
    transition: 'all ease 0.3s',
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: theme.colors.neutral.w100,
    },
}));

export const AddLabelWrapper = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '5px',
    width: '190px',
}));

export const HoverLabel = styled('p')<{ $hovering?: boolean; $leftOffset?: number }>(
    ({ theme, $hovering, $leftOffset }) => ({
        color: theme.colors.neutral.w700,
        fontSize: theme.font.smallSize,
        lineHeight: 1.5,
        visibility: $hovering ? 'visible' : 'hidden',
        transition: 'opacity ease 0.3s',
        marginLeft: $leftOffset ? `${$leftOffset}px` : '',
    })
);
